const LAND_PROPERTY_TYPES = ['Land', 'Farm']

export const isLandPropertyType = status => LAND_PROPERTY_TYPES.indexOf(status) > -1
